(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-product-shelf"] && !Shopify.designMode) return;
  try {
    
  class DDProductShelf extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'carousel' || this.controller) return;
      this.track = this.querySelector('.dd-shelf__products');
      this.controls = this.querySelector('.dd-shelf__controls');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.controls) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.previous.addEventListener('click',() => this.move(-1),options);
      this.next.addEventListener('click',() => this.move(1),options);
      this.track.addEventListener('scroll',() => this.update(),{...options,passive:true});
      this.observer = new ResizeObserver(() => this.update());
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.nearViewport = entries.some(entry => entry.isIntersecting);
        if (this.nearViewport) {
          this.observer.observe(this.track);
          this.update();
        } else this.observer.unobserve(this.track);
      },{rootMargin:'600px 0px'});
      this.visibilityObserver.observe(this.closest('.dd-shelf') || this);
    }
    update() {
      if (!this.nearViewport) return;
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = maximum < 2;
      const media = this.track.querySelector('.dd-card__media');
      if (media) this.style.setProperty('--dd-arrow-y',`${media.offsetTop + media.offsetHeight / 2}px`);
      this.previous.disabled = position < 2;
      this.next.disabled = position >= maximum - 2;
    }
    move(direction) {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({left:this.track.clientWidth * direction * (rtl ? -1 : 1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      this.controller = null;
    }
  }
  if (!customElements.get('dd-product-shelf')) customElements.define('dd-product-shelf',DDProductShelf);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
